/** Keep in sync with userUpdateModelInputSchema in server/utils/modelValidation.ts */
export const USER_UPDATE_MODEL_FIELD_KEYS = [
  "artist",
  "genre",
  "gender",
  "isPrivate",
  "isCommunityModel",
  "isCopyrightFree",
  "isInstrumental",
  "thumbnail",
  "audioPreviewUrl",
  "createdBy",
  "sampleRate",
  "f0Method",
  "epochCount",
  "batchSize",
  "isClusterTrained",
  "status",
] as const;

export type UserUpdateModelField =
  (typeof USER_UPDATE_MODEL_FIELD_KEYS)[number];

/** Client-safe subset — never sends userId or other server-owned fields. */
export function pickUserUpdateModelFields(
  model: Record<string, unknown>
): Partial<Record<UserUpdateModelField, unknown>> {
  const picked: Partial<Record<UserUpdateModelField, unknown>> = {};

  for (const key of USER_UPDATE_MODEL_FIELD_KEYS) {
    if (model[key] !== undefined) {
      picked[key] = model[key];
    }
  }

  return picked;
}
